class NativeVideo extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
    if (this.autoPlay) {
      this.play();
    } else {
      this.addEventListener("click", this.play.bind(this), { once: true });
    }
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video").play();
    this.classList.remove("native-video--stopped");
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  _replaceContent() {
    let node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    if (!this.hasAttribute("autoplay")) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    this.firstElementChild.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    this.firstElementChild.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
  }
};
window.customElements.define("native-video", NativeVideo);


class FAQVideos extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll(".faq-video").forEach((element) => {
      element.addEventListener("click", this.videoClick.bind(this));
    });

    this.querySelectorAll("native-video").forEach((element) => {
      element.addEventListener("video:played", this.videoPlayed.bind(this));
    });
  }

  get player() {
    return this.querySelector("native-video");
  }

  videoClick(event) {
    const button = event.target.closest(".faq-video");
    const videoTag = button.querySelector(".faq-video__block-template");
    const videoImage = button.querySelector('.faq-video__preview-image');

    const player = this.player;
    const playerImage = this.player.querySelector("img");
    // const playerVideo = this.player.querySelector("video");
    const playerTemplate = this.player.querySelector(".native-video__template");

    if (playerImage) {
      const temp = document.createElement("div");
      temp.innerHTML = videoImage.outerHTML;

      playerImage.parentNode.replaceChild(temp.firstChild, playerImage);
    }

    if (playerTemplate) {
      playerTemplate.innerHTML = videoTag.innerHTML;
    } else {
      const template = document.createElement("template");
      const image = document.createElement("div");

      template.innerHTML = videoTag.innerHTML;
      image.innerHTML = videoImage.outerHTML;

      player.innerHTML = "";
      player.appendChild(image.firstChild);
      player.appendChild(template);

      player.hasLoaded = false;
      player.play();
    }
  }

  videoPlayed(event) {
    const video = event.target;

    this.goFullscreenMobile(video);
  }

  goFullscreenMobile(video) {
    if (video) {
      if (window.innerWidth <= 999) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        } else if (video.mozRequestFullscreen) {
          video.mozRequestFullscreen();
        }
      }
    }
  }
}
window.customElements.define("faq-videos", FAQVideos);
